/**
 * I'll make sure that parts of the site that want to be 100vh tall will look
 * alright in mobile browsers. Why a variable and JS? Well, mobile browsers have
 * an address bar, and this address bar shrinks as you scroll down. So, the
 * consensus amongst browser developers was to set 100vh to the MAX innerHeight,
 * not the INITIAL innerHeight. This causes our product order form to not be
 * fully visible when you first load a product page.
 */
export function initMobileBrowser100vhFix() {
	const root = document.documentElement

	doUpdate()
	$(window).on('resize', doUpdate)

	function doUpdate() {
		root.style.setProperty('--vh100', window.innerHeight + 'px')
	}
}